import styled from 'styled-components';
import {
  Flex, Headline, Text, mediaQueries,
  Button as SliceButton,
  Script as SliceScript
} from '@lce/slice';

export const MessageBox = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 480px;
  float: right;
  padding: 2.75rem 1rem 1rem 1rem;
  background: rgba(255, 255, 255, 0.8);

  ${mediaQueries[1]} {
    margin: 3.25rem 0.75rem 3.25rem auto;
    padding: 2rem 1.5rem 1.5rem 2rem;
  }
`;

export const Title = styled(Headline)`
  margin-bottom: 0;
  color: ${props => props.theme.colors.orange};
  font-size: 3.25rem;
  line-height: 0.8;

  ${mediaQueries[0]} {
    font-size: 3.25rem;
  }
`;

export const Script = styled(SliceScript).attrs({
  tilt: 3,
})`
  position: relative;
  margin-top: -4px;
  color: ${props => props.theme.colors.black};
  line-height: 0.8;
`;

export const Message = styled(Text)`
  margin-top: 1rem;
  margin-bottom: 2rem;
  line-height: 20px;
  color: ${props => props.theme.colors.black};
`;

export const Button = styled(SliceButton)`
  align-self: flex-end;
  font-size: 1.5rem;
  text-transform: uppercase;
  color: ${props => props.theme.colors.orange};
  border-width: 0.25rem;
  background: transparent;
`;
